import "~/misc/common"; // MUST be first

import "~/styles/application.scss";

import 'jquery-ui-dist/jquery-ui';

import 'popper.js';
import 'bootstrap';
import 'hammerjs';
import "font-awesome/css/font-awesome.css";
import "@nathanvda/cocoon";

// Plugins (some may need paths adjusted)
import { initDatetimepicker } from "~/misc/datetimepicker";

import '~/misc/invertable';
import '~/misc/select2';
import '~/misc/pickers';
import '~/misc/minicolors';
import '~/misc/textarea';
import '~/misc/autonumeric_init';

import "~/styles/vendor/lc_switch.scss";
import "~/misc/vendor/lc_switch.min.js";

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
import Rails from "@rails/ujs";
Rails.start();
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import { registerControllers } from "~/controllers";

$(() => {
  initDatetimepicker();
  registerControllers();
});

